function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * `HttpHeaders` class represents the header configuration options for an HTTP request.
 * Instances should be assumed immutable with lazy parsing.
 *
 * @publicApi
 */
export var HttpHeaders = /*#__PURE__*/function () {
  /**  Constructs a new HTTP header object with the given values.*/

  function HttpHeaders(headers) {
    var _this = this;
    _classCallCheck(this, HttpHeaders);
    /**
     * Internal map of lowercase header names to values.
     */
    // TODO(issue/24571): remove '!'.
    _defineProperty(this, "headers", void 0);
    /**
     * Internal map of lowercased header names to the normalized
     * form of the name (the form seen first).
     */
    _defineProperty(this, "normalizedNames", new Map());
    /**
     * Complete the lazy initialization of this object (needed before reading).
     */
    // TODO(issue/24571): remove '!'.
    _defineProperty(this, "lazyInit", void 0);
    /**
     * Queued updates to be materialized the next initialization.
     */
    _defineProperty(this, "lazyUpdate", null);
    if (!headers) {
      this.headers = new Map();
    } else if (typeof headers === 'string') {
      this.lazyInit = function () {
        _this.headers = new Map();
        headers.split('\n').forEach(function (line) {
          var index = line.indexOf(':');
          if (index > 0) {
            var _name = line.slice(0, index);
            var key = _name.toLowerCase();
            var value = line.slice(index + 1).trim();
            _this.maybeSetNormalizedName(_name, key);
            if (_this.headers.has(key)) {
              _this.headers.get(key).push(value);
            } else {
              _this.headers.set(key, [value]);
            }
          }
        });
      };
    } else {
      this.lazyInit = function () {
        _this.headers = new Map();
        Object.keys(headers).forEach(function (name) {
          var values = headers[name];
          var key = name.toLowerCase();
          if (typeof values === 'string') {
            values = [values];
          }
          if (values.length > 0) {
            _this.headers.set(key, values);
            _this.maybeSetNormalizedName(name, key);
          }
        });
      };
    }
  }

  /**
   * Checks for existence of a header by a given name.
   *
   * @param name The header name to check for existence.
   *
   * @returns Whether the header exits.
   */
  _createClass(HttpHeaders, [{
    key: "has",
    value: function has(name) {
      this.init();
      return this.headers.has(name.toLowerCase());
    }

    /**
     * Returns the first header value that matches a given name.
     *
     * @param name The header name to retrieve.
     *
     * @returns A string if the header exists, null otherwise
     */
  }, {
    key: "get",
    value: function get(name) {
      this.init();
      var values = this.headers.get(name.toLowerCase());
      return values && values.length > 0 ? values[0] : null;
    }

    /**
     * Returns the names of the headers.
     *
     * @returns A list of header names.
     */
  }, {
    key: "keys",
    value: function keys() {
      this.init();
      return Array.from(this.normalizedNames.values());
    }

    /**
     * Returns a list of header values for a given header name.
     *
     * @param name The header name from which to retrieve the values.
     *
     * @returns A string of values if the header exists, null otherwise.
     */
  }, {
    key: "getAll",
    value: function getAll(name) {
      this.init();
      return this.headers.get(name.toLowerCase()) || null;
    }

    /**
     * Appends a new header value to the existing set of
     * header values.
     *
     * @param name The header name for which to append the values.
     *
     * @returns A clone of the HTTP header object with the value appended.
     */
  }, {
    key: "append",
    value: function append(name, value) {
      return this.clone({
        name: name,
        value: value,
        op: 'a'
      });
    }
    /**
     * Sets a header value for a given name. If the header name already exists,
     * its value is replaced with the given value.
     *
     * @param name The header name.
     * @param value Provides the value to set or overide for a given name.
     *
     * @returns A clone of the HTTP header object with the newly set header value.
     */
  }, {
    key: "set",
    value: function set(name, value) {
      return this.clone({
        name: name,
        value: value,
        op: 's'
      });
    }
    /**
     * Deletes all header values for a given name.
     *
     * @param name The header name.
     * @param value The header values to delete for a given name.
     *
     * @returns A clone of the HTTP header object.
     */
  }, {
    key: "delete",
    value: function _delete(name, value) {
      return this.clone({
        name: name,
        value: value,
        op: 'd'
      });
    }
  }, {
    key: "maybeSetNormalizedName",
    value: function maybeSetNormalizedName(name, lcName) {
      if (!this.normalizedNames.has(lcName)) {
        this.normalizedNames.set(lcName, name);
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;
      if (!!this.lazyInit) {
        if (this.lazyInit instanceof HttpHeaders) {
          this.copyFrom(this.lazyInit);
        } else {
          this.lazyInit();
        }
        this.lazyInit = null;
        if (!!this.lazyUpdate) {
          this.lazyUpdate.forEach(function (update) {
            return _this2.applyUpdate(update);
          });
          this.lazyUpdate = null;
        }
      }
    }
  }, {
    key: "copyFrom",
    value: function copyFrom(other) {
      var _this3 = this;
      other.init();
      Array.from(other.headers.keys()).forEach(function (key) {
        _this3.headers.set(key, other.headers.get(key));
        _this3.normalizedNames.set(key, other.normalizedNames.get(key));
      });
    }
  }, {
    key: "clone",
    value: function clone(update) {
      var clone = new HttpHeaders();
      clone.lazyInit = !!this.lazyInit && this.lazyInit instanceof HttpHeaders ? this.lazyInit : this;
      clone.lazyUpdate = (this.lazyUpdate || []).concat([update]);
      return clone;
    }
  }, {
    key: "applyUpdate",
    value: function applyUpdate(update) {
      var key = update.name.toLowerCase();
      switch (update.op) {
        case 'a':
        case 's':
          var value = update.value;
          if (typeof value === 'string') {
            value = [value];
          }
          if (value.length === 0) {
            return;
          }
          this.maybeSetNormalizedName(update.name, key);
          var base = (update.op === 'a' ? this.headers.get(key) : undefined) || [];
          base.push.apply(base, _toConsumableArray(value));
          this.headers.set(key, base);
          break;
        case 'd':
          var toDelete = update.value;
          if (!toDelete) {
            this.headers.delete(key);
            this.normalizedNames.delete(key);
          } else {
            var existing = this.headers.get(key);
            if (!existing) {
              return;
            }
            existing = existing.filter(function (value) {
              return toDelete.indexOf(value) === -1;
            });
            if (existing.length === 0) {
              this.headers.delete(key);
              this.normalizedNames.delete(key);
            } else {
              this.headers.set(key, existing);
            }
          }
          break;
      }
    }

    /**
     * @internal
     */
  }, {
    key: "forEach",
    value: function forEach(fn) {
      var _this4 = this;
      this.init();
      Array.from(this.normalizedNames.keys()).forEach(function (key) {
        return fn(_this4.normalizedNames.get(key), _this4.headers.get(key));
      });
    }
  }]);
  return HttpHeaders;
}();